import { useState } from 'react';
import { motion } from 'framer-motion';
import { REEL } from './data';

// WORK — long vertical full-bleed reel theatre. Each film occupies a full-width
// strip with a single image, mono caption, and a "Now playing" treatment.
export default function Work() {
  const cats = ['All', ...new Set(REEL.map(r => r.type))];
  const [cat, setCat] = useState('All');
  const list = cat === 'All' ? REEL : REEL.filter(r => r.type === cat);
  return (
    <div className="bg-[#0A0908] text-[#FBF6E8]">
      <section className="pt-32 pb-10 max-w-[1500px] mx-auto px-6 lg:px-12 border-b border-[#FBF6E8]/10">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#C9963E] mb-4">— Index 02 / The reel</p>
        <h1 className="font-serif text-[44px] sm:text-[72px] lg:text-[112px] leading-[0.92] tracking-[-0.025em]">Forty-seven films, <span className="italic text-[#C9963E]">in eleven years</span>.</h1>
      </section>

      {/* Filter pills */}
      <div className="border-b border-[#FBF6E8]/10 sticky top-16 bg-[#0A0908]/95 backdrop-blur-md z-30">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-4 flex flex-wrap items-center gap-2 font-mono text-[10px] tracking-[0.22em] uppercase">
          <span className="text-[#FBF6E8]/45 mr-2">Filter</span>
          {cats.map(c => (
            <button key={c} onClick={() => setCat(c)} data-testid={`film-cat-${c}`}
              className={`px-3 py-1.5 transition-colors ${cat === c ? 'bg-[#C9963E] text-[#0A0908]' : 'border border-[#FBF6E8]/15 text-[#FBF6E8]/65 hover:border-[#FBF6E8]/40'}`}>
              {c}
            </button>
          ))}
        </div>
      </div>

      {/* Reel theatre — alternating left/right with full-bleed image */}
      <section className="space-y-px bg-[#FBF6E8]/10">
        {list.map((r, i) => (
          <motion.div key={r.title} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="bg-[#0A0908]">
            <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-10 grid lg:grid-cols-[1.6fr_1fr] gap-10 items-center">
              <div className="relative aspect-[16/9] overflow-hidden group cursor-pointer">
                <img src={r.poster} alt={r.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" loading="lazy" />
                <div className="absolute inset-0 bg-[#0A0908]/40 group-hover:bg-[#0A0908]/15 transition-colors" />
                <span className="absolute top-4 left-4 font-mono text-[9px] tracking-[0.4em] uppercase bg-[#C9963E] text-[#0A0908] px-2 py-1">{r.type}</span>
                <div className="absolute bottom-4 left-4 right-4 flex justify-between font-mono text-[10px] tracking-[0.3em] uppercase text-[#FBF6E8]/85">
                  <span>FILM Nº {String(i + 1).padStart(3, '0')}</span>
                  <span className="text-[#C9963E]">{r.runtime}</span>
                </div>
              </div>
              <div>
                <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#C9963E] mb-3">{r.client} · {r.yr}</p>
                <h2 className="font-serif text-3xl lg:text-5xl leading-[0.95]">{r.title}</h2>
                <ul className="mt-6 space-y-2">
                  {r.festivals.map(f => (
                    <li key={f} className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#FBF6E8]/65 flex items-center gap-2">
                      <span className="w-1 h-1 bg-[#C9963E] rounded-full" /> {f}
                    </li>
                  ))}
                </ul>
                <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9963E] hover:text-[#FBF6E8] mt-8 cursor-pointer inline-block border-b border-[#C9963E]">▸ Watch full film</p>
              </div>
            </div>
          </motion.div>
        ))}
      </section>
    </div>
  );
}
